import React from "react";
import { useIntl } from "react-intl";
import { Text, Tag } from "react_reusable_components";

import { TwoColumn } from "../../core/layouts";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import variables from "../../themes/base/styles/variables";
import {
  formatDate,
  getConditionalContent,
  getLocalizedMessage,
} from "../../UtilityFunctions/utils";
import Styles from "./viewQuestionnaireTopContainerStyles.module.scss";

const ViewQuestionnaireTopContainerStyle = {
  mainWrapper: {
    background: variables.bodyBg,
    padding: variables.paddingSmall,
    gap: variables.gapSmall,
    width: variables.fullWidth,
    border: `1px solid ${variables.grey4}`,
    overflow: "unset",
    marginRight: variables.paddingMedium,
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "minmax(1vw, auto) auto",
  },
  tagStyle: {
    borderRadius: variables.radiusXXLarge,
    padding: `${variables.marginXSmallest} ${variables.marginMediumSmall}`,
    height: variables.tagHeight,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    border: variables.tagBorder,
    margin: 0,
  },
  leftColumnsStyle: {
    gap: variables.gapSmaller,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    alignSelf: "end",
  },
  collapseIcon: {
    width: variables.iconWidth,
    height: variables.iconHeight,
    cursor: "pointer",
  },
};

const ViewQuestionnaireTopContainer = ({
  questionnaireName,
  isOperational,
  isPrimary,
  setCollapseTop,
  mode,
  reAuditDueDate,
}) => {
  const intl = useIntl();
  const isQuestionnaire = window.location.href.includes("questionnaire");
  return (
    <TwoColumn
      onClick={() => {
        mode !== "view" && setCollapseTop(false);
      }}
      style={{
        ...ViewQuestionnaireTopContainerStyle.mainWrapper,
        ...(mode !== "view" && { cursor: "pointer" }),
      }}
      leftSection={
        <Text type="secondary" className={Styles["questionnaire-name"]}>
          {questionnaireName}
        </Text>
      }
      rightSection={
        isQuestionnaire ? (
          <ThreeColumn
            style={ViewQuestionnaireTopContainerStyle.leftColumnsStyle}
            leftSection={
              <Text type="secondary" className={Styles["questionnaire-type"]}>
                {getLocalizedMessage(
                  intl,
                  getConditionalContent({
                    condition: isOperational,
                    trueValue: "manageQuestionnaire.operational",
                    falseValue: "manageQuestionnaire.repair",
                  })
                )}
              </Text>
            }
            middleSectionStyle={getConditionalContent({
              condition: !isOperational || !isPrimary,
              trueValue: { display: "none" },
              falseValue: {},
            })}
            middleSection={
              isOperational &&
              isPrimary && (
                <Tag
                  color={variables.lightCraftingBlue}
                  style={ViewQuestionnaireTopContainerStyle.tagStyle}
                >
                  <Text
                    type="secondary"
                    className={Styles["questionnaire-type"]}
                  >
                    {getLocalizedMessage(intl, "manageQuestionnaire.primary")}
                  </Text>
                </Tag>
              )
            }
            rightSectionStyle={getConditionalContent({
              condition: mode === "view",
              trueValue: { display: "none" },
              falseValue: {},
            })}
            rightSection={
              mode !== "view" && (
                <img
                  style={ViewQuestionnaireTopContainerStyle.collapseIcon}
                  alt="collapseIcon"
                  src={"/icons/collapseIcon.png"}
                  onClick={() => {
                    setCollapseTop(false);
                  }}
                />
              )
            }
          />
        ) : (
          reAuditDueDate && (
            <TwoColumn
              style={{
                alignSelf: "end",
              }}
              leftSection={
                <Text className={Styles["date-heading"]}>
                  {getLocalizedMessage(intl, "mangeAudit.F2F.auditDueHeading")}
                  &nbsp;:&nbsp;
                </Text>
              }
              rightSection={
                <Text className={Styles["questionnaire-type"]} type="secondary">
                  {getConditionalContent({
                    condition: reAuditDueDate,
                    trueValue: formatDate(reAuditDueDate, intl),
                    falseValue: "-",
                  })}
                </Text>
              }
            />
          )
        )
      }
    />
  );
};

export default ViewQuestionnaireTopContainer;
